import React, {useState, useEffect, useContext, useCallback} from "react";
import {
    Page,
    Layout,
    Card,
    SkeletonBodyText,
    SkeletonDisplayText, FormLayout, Form, TextField, List, Button
} from "@shopify/polaris";
import {useParams, useHistory} from "react-router-dom";
import WhatsappChatWindow from "../../components/WhatsappChatWindow";
import {getShortcodeLists, parseShortcodes} from "../../utils";
import ExampleMessageTemplates from "./ExampleMessageTemplates";
import axios from "../../axios";
import {ShopContext} from "../../App";
import Notice from "../../components/Notice";

const CreateOrEditTemplate = () => {
    const config = useContext(ShopContext);
    const router = useHistory();
    const {id, task, type} = useParams();
    const [templateId, setTemplateId] = useState(parseInt(id));
    const [messageText, setMessageText] = useState("");
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [showNotice, setShowNotice] = useState(false);
    const [noticeMessage, setNoticeMessage] = useState("");
    const [noticeType, setNoticeType] = useState("info");

    let cart = {
        firstname: "John",
        lastname: "paul",
        total_amount: "100",
        presentment_currency: "USD",
        recovery_url: "http://sampleurl.test/recover=ajxhdgjhfefrekjgehj"
    };
    let shortcodes = getShortcodeLists(cart, type);
    let parsedMessageTemplate = parseShortcodes(messageText, shortcodes);

    const loadTemplate = useCallback(() => {
        if (templateId && templateId > 0) {
            setLoading(true);
            axios.get(`/templates/${templateId}`, {
                "headers": {
                    shopOrigin: config.shopOrigin,
                    xShopHost: config.host,
                }
            }).then((response) => {
                let data = {
                    text: response.data.message_text,
                    id: response.data.id,
                };
                setMessageText(data.text);
                setLoading(false);
            }).catch((e) => {
                setLoading(false);
            });
        }
    }, [config, templateId]);
    useEffect(() => {
        loadTemplate();
    }, [templateId, loadTemplate])
    /**
     * Save the template
     **/
    let saveTemplate = (close = false) => {
        let modifiedTemplate = JSON.stringify({
            id: templateId,
            message_text: messageText,
            type: type
        });
        setSaving(true);
        axios.post(`/templates`, modifiedTemplate, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        })
            .then((response) => {
                setShowNotice(true);
                setNoticeMessage(response.message);
                if (response.success) {
                    setTemplateId(response.data.id);
                    setNoticeType('success');
                } else {
                    setNoticeType('critical');
                }
                setSaving(false);
                if (close) {
                    router.goBack();
                }
            }).catch((error) => {
            setSaving(false);
            setShowNotice(true);
            setNoticeMessage("Error in saving template!");
            setNoticeType('critical');
        });

    }

    return (
        <Page
            breadcrumbs={[{
                accessibilityLabel: 'Templates',
                disabled: saving,
                content: 'Templates',
                onAction: () => {
                    router.goBack();
                }
            }]}
            fullWidth={true}
            title={(task === "edit") ? "Edit template" : "Create template"}
            primaryAction={{
                content: 'Save and close', onAction: () => {
                    saveTemplate(true);
                },
                disabled: saving,
                loading: saving
            }}
            secondaryActions={[{
                content: 'Cancel',
                disabled: saving,
                onAction: () => {
                    router.goBack();
                }
            }]}
            separator
        >
            <Notice message={noticeMessage} show={showNotice} onClose={() => {
                setShowNotice(false);
            }} status={noticeType}/>
            <Layout>
                <Layout.Section>
                    {loading && <Card>
                        <Card.Section>
                            <SkeletonDisplayText size="small"/>
                            <div>&nbsp;</div>
                            <SkeletonBodyText lines={3}/>
                            <div>&nbsp;</div>
                            <SkeletonDisplayText size="small"/>
                            <div>&nbsp;</div>
                            <SkeletonBodyText lines={3}/>
                            <div>&nbsp;</div>
                            <SkeletonDisplayText size="small"/>
                            <div>&nbsp;</div>
                            <SkeletonBodyText lines={3}/>
                        </Card.Section>
                    </Card>}
                    {!loading && <>
                        <Card title="Template details" sectioned>
                            <FormLayout>
                                <Form onSubmit={() => {
                                    saveTemplate(false);
                                }}>
                                    <TextField label="Message text" onChange={(value) => {
                                        setMessageText(value);
                                    }} multiline={5} value={messageText} helpText={(<div>
                                        <p>Use the below shortcodes to generate the message</p>
                                        <div>
                                            <List type="number">
                                                {shortcodes.map((shortcode) => {
                                                    return (<List.Item
                                                        key={shortcode.search}><strong>{shortcode.search}</strong>: {shortcode.description}
                                                    </List.Item>)
                                                })}
                                            </List>
                                        </div>
                                    </div>)}/>
                                    <div>&nbsp;</div>
                                    <Button submit primary loading={saving}>Save</Button>
                                </Form>
                            </FormLayout>
                        </Card>
                    </>}
                </Layout.Section>
                <Layout.Section secondary>
                    <Card title="Preview" sectioned>
                        <WhatsappChatWindow message={parsedMessageTemplate}/>
                        <div>&nbsp;</div>
                        <ExampleMessageTemplates/>
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>)
}

export default CreateOrEditTemplate;
